import _ from 'lodash';
import moment from 'moment';
import { MyXLSX2 } from '@/utils/xlsxExport2';
import { PAY_WAY_LIST, accountingStatusOptions } from '@/assets/commonData/options';

let CD;

export default {
    created() {
        CD = moment().format('YYYY-MM-DD');
    },
    methods: {
        async onExport() {
            const wb = MyXLSX2.createBook();
            this.isLoadingExport = true;

            try {
                const { type, sheet } = await this.getSheetData();

                MyXLSX2.bookAppendSheet(wb, sheet, '帳務匯總表');
                MyXLSX2.download(wb, `${type}帳務匯總表 ${CD}`);
            } catch (e) {
                console.log(e);
                this.$message({
                    showClose: true,
                    message: '無資料可匯出',
                    type: 'error',
                });
            } finally {
                this.isLoadingExport = false;
            }
        },

        async getSheetData() {
            const details = await this.getExportData({ ...this.conditions });

            switch (this.QueryType) {
            case 1:
                return { type: '發票', sheet: this.getInvoiceSheet(details) };
            case 2:
                return { type: '請款單', sheet: this.getPaymentSheet(details) };
            case 3:
            case 4:
            case 5:
            case 6:
                return { type: '財務單', sheet: this.getVariableStatementSheet(details) };
            case 7:
                return { type: '薪資支出', sheet: this.getSalarySheet(details) };
            case 8:
                return { type: '借款管理', sheet: this.getLoanSheet(details) };
            case 9:
                return { type: '存款帳戶互轉', sheet: this.getBankTransferSheet(details) };
            case 10:
                return { type: '零用現金', sheet: this.getPettyMoneySheet(details) };
            default:
                return [];
            }
        },

        async getExportData(params) {
            const PageSize = 1000;
            let PageNum = 1;

            let subUrl;
            let QueryType;
            let LoanReceiptSno;
            switch (this.QueryType) {
            case 1:
                subUrl = 'GetInvoiceList';
                break;
            case 2:
                subUrl = 'GetPayoutList';
                break;
            case 3:
            case 4:
            case 5:
            case 6:
                subUrl = 'GetVariableStatementList';
                QueryType = this.QueryType;
                break;
            case 7:
                subUrl = 'GetSalaryList';
                break;
            case 8:
                subUrl = 'GetLoanDrawdownRepaymentList';
                LoanReceiptSno = this.loanReceiptSno;
                break;
            case 9:
                subUrl = 'GetAccountTransferRecordList';
                break;
            case 10:
                subUrl = 'GetPettyCashList';
                break;
            default:
            }

            const { query, resetQuery } = this.getManualQuery(params);
            const url = `AccountingSummaryPage/${subUrl}${query}`;

            const { data } = await this.$api({
                url,
                method: 'GET',
                params: {
                    ...params,
                    ...resetQuery,
                    QueryType,
                    LoanReceiptSno,
                    PageNum: 1,
                    PageSize,
                },
            });

            // 足夠的PageSize
            if (PageSize > data.totalNum) {
                return data.items;
            }

            const currentList = [...data.items];
            for (let i = 0; i < Math.ceil(data.totalNum / PageSize) - 1; i += 1) {
                PageNum += 1;
                // eslint-disable-next-line no-await-in-loop
                const resp = await this.$api({
                    url,
                    method: 'GET',
                    params: { ...params, PageNum, PageSize },
                });
                currentList.push(...resp.data.items);
            }
            return currentList;
        },

        getInvoiceSheet(details) {
            if (!details.length) return null;

            // 內容表頭
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '系統單號', align: 'center' },
                { text: '財會檢核', width: 10, align: 'center' },
                {
                    text: '核准傳票',
                    width: 9,
                    align: 'center',
                    number: true,
                },
                {
                    text: '待辦傳票',
                    width: 9,
                    align: 'center',
                    number: true,
                },
                { text: '摘要', width: 30, align: 'left' },
                { text: '收入項目', align: 'left' },
                { text: '憑證類型', align: 'left' },
                { text: '發票號碼', align: 'center' },
                { text: '發票開立日', align: 'center' },
                { text: '銷售額(未稅)', align: 'right', number: true },
                { text: '稅金', align: 'right', number: true },
                { text: '含稅總計', align: 'right', number: true },
                { text: '幣別', width: 8, align: 'center' },
                {
                    text: '匯率',
                    width: 8,
                    align: 'right',
                },
                { text: '(最新) 入帳方式', align: 'center' },
                {
                    text: '入帳筆數',
                    width: 10,
                    align: 'center',
                    number: true,
                },
                { text: '(最新) 入帳日期', align: 'center' },
                { text: '入帳總額', align: 'right', number: true },
                { text: '(最新) 銀行帳戶', align: 'left' },
                { text: '折讓日期', align: 'center' },
                { text: '折讓金額', align: 'right', number: true },
                { text: '建立日期', align: 'center' },
            ];

            // 內容資料
            const bodyRows = [];
            details.forEach((item) => {
                const row = [
                    // 資訊
                    '',
                    item.uniqueNumber,
                    this.statusTxt(item.vocherStatus),
                    item.approvedVocherQty,
                    item.vocherQty - item.approvedVocherQty,
                    item.summary,
                    item.iteM_NAM,
                    `${item.typeName}${item.tranInvoiceCount > 0 ? '(已轉開)' : ''}`,
                    item.foo,
                    moment(item.foO_DAT).format('YYYY-MM-DD'),
                    item.amount - item.amT_TAX,
                    item.amT_TAX,
                    item.amount,
                    item.cny,
                    item.rat,
                    this.getTransferTypeText(item.incomeTransferType),
                    item.incomeCount,
                    item.incomeBnkDat ? moment(item.incomeBnkDat).format('YYYY-MM-DD') : '--',
                    item.incomeTotalAmount || '--',
                    item.incomeBnkNam || '--',
                    item.foO_DIS ? moment(item.foO_DIS_DAT).format('YYYY-MM-DD') : '--',
                    item.foO_DIS ? item.foO_DIS_AMT : '--',
                    moment(item.crT_DAT).format('YYYY-MM-DD'),
                ];
                bodyRows.push(row);
            });

            // 總計列
            bodyRows.push([
                '',
                '總計',
                '',
                _.sumBy(details, 'approvedVocherQty'),
                _.sumBy(details, (o) => o.vocherQty - o.approvedVocherQty),
                '',
                '',
                '',
                '',
                '',
                _.sumBy(details, (o) => o.amount - o.amT_TAX),
                _.sumBy(details, 'amT_TAX'),
                _.sumBy(details, 'amount'),
                '',
                '',
                '',
                _.sumBy(details, 'incomeCount'),
                '',
                _.sumBy(details, 'incomeTotalAmount'),
                '',
                '',
                _.sumBy(details, 'foO_DIS_AMT'),
                '',
            ]);

            // 表頭資訊
            const headRows = [
                { label: this.getDateQueryTypeTxt(), value: `${moment(+this.conditions.StartDate).format('YYYY-MM-DD')} ~ ${moment(+this.conditions.EndDate).format('YYYY-MM-DD')}` },
                { label: '製表日期', value: CD },
            ];

            return MyXLSX2.createSheet('發票帳務匯總表', headRows, bodyHeader, bodyRows);
        },

        getPaymentSheet(details) {
            if (!details.length) return null;

            // 內容表頭
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '系統單號', align: 'center' },
                { text: '財會檢核', width: 10, align: 'center' },
                {
                    text: '核准傳票',
                    width: 9,
                    align: 'center',
                    number: true,
                },
                {
                    text: '待辦傳票',
                    width: 9,
                    align: 'center',
                    number: true,
                },
                { text: '摘要', width: 30, align: 'left' },
                { text: '支出項目', align: 'left' },
                { text: '請款單日期', align: 'center' },
                {
                    text: '憑證',
                    width: 7,
                    align: 'center',
                    number: true,
                },
                { text: '單據總額', align: 'right', number: true },
                {
                    text: '代扣所得稅(TWD)',
                    width: 20,
                    align: 'right',
                    number: true,
                },
                {
                    text: '代扣二代健保(TWD)',
                    width: 20,
                    align: 'right',
                    number: true,
                },
                { text: '實付金額', align: 'right', number: true },
                { text: '幣別', width: 8, align: 'center' },
                {
                    text: '匯率',
                    width: 8,
                    align: 'right',
                },
                { text: '付款方式', align: 'center' },
                { text: '付款日期', align: 'center' },
                { text: '付款總額', align: 'right', number: true },
                { text: '銀行帳戶', align: 'left' },
                { text: '建立日期', align: 'center' },
            ];

            // 內容資料
            const bodyRows = [];
            details.forEach((item) => {
                const row = [
                    // 資訊
                    '',
                    item.uniqueNumber,
                    this.statusTxt(item.vocherStatus),
                    item.approvedVocherQty,
                    item.vocherQty - item.approvedVocherQty,
                    item.summary,
                    item.iteM_NAM,
                    moment(item.dat).format('YYYY-MM-DD'),
                    item.documentCount,
                    item.amount,
                    Math.round(item.taX_AMT * item.rat),
                    Math.round(item.geN2_AMT * item.rat),
                    item.amount - item.taX_AMT - item.geN2_AMT,
                    item.cny,
                    item.rat,
                    this.gePaymentPayWayText(item.paY_WAY),
                    item.paY_DAT ? moment(item.paY_DAT).format('YYYY-MM-DD') : '--',
                    item.amount - item.taX_AMT - item.geN2_AMT,
                    item.bankName || '--',
                    moment(item.crT_DAT).format('YYYY-MM-DD'),
                ];
                bodyRows.push(row);
            });

            // 總計列
            bodyRows.push([
                '',
                '總計(約當台幣)',
                '',
                _.sumBy(details, 'approvedVocherQty'),
                _.sumBy(details, (o) => o.vocherQty - o.approvedVocherQty),
                '',
                '',
                '',
                _.sumBy(details, 'documentCount'),
                _.sumBy(details, (o) => Math.round(o.amount * o.rat)),
                _.sumBy(details, (o) => Math.round(o.taX_AMT * o.rat)),
                _.sumBy(details, (o) => Math.round(o.geN2_AMT * o.rat)),
                _.sumBy(details, (o) => Math.round(o.amount * o.rat) - Math.round(o.taX_AMT * o.rat) - Math.round(o.geN2_AMT * o.rat)),
                '',
                '',
                '',
                '',
                _.sumBy(details, (o) => Math.round(o.amount * o.rat) - Math.round(o.taX_AMT * o.rat) - Math.round(o.geN2_AMT * o.rat)),
                '',
                '',
            ]);

            // 表頭資訊
            const headRows = [
                { label: this.getDateQueryTypeTxt(), value: `${moment(+this.conditions.StartDate).format('YYYY-MM-DD')} ~ ${moment(+this.conditions.EndDate).format('YYYY-MM-DD')}` },
                { label: '製表日期', value: CD },
            ];

            return MyXLSX2.createSheet('請款單帳務匯總表', headRows, bodyHeader, bodyRows);
        },

        getVariableStatementSheet(details) {
            if (!details.length) return null;

            // 內容表頭
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '系統單號', align: 'center' },
                { text: '財會檢核', width: 10, align: 'center' },
                {
                    text: '核准傳票',
                    width: 9,
                    align: 'center',
                    number: true,
                },
                {
                    text: '待辦傳票',
                    width: 9,
                    align: 'center',
                    number: true,
                },
                { text: '摘要', width: 30, align: 'left' },
                { text: '支出/收入項目', align: 'left' },
                { text: '出入帳日期', align: 'center' },
                { text: '支出/收入金額', align: 'right', number: true },
                { text: '幣別', width: 8, align: 'center' },
                {
                    text: '匯率',
                    width: 8,
                    align: 'right',
                },
                {
                    text: '交易方式',
                    width: 10,
                    align: 'left',
                    number: true,
                },
                { text: '銀行帳戶', align: 'left' },
                { text: '建立日期', align: 'center' },
            ];

            // 內容資料
            const bodyRows = [];
            details.forEach((item) => {
                const row = [
                    // 資訊
                    '',
                    item.uniqueNumber,
                    this.statusTxt(item.vocherStatus),
                    item.approvedVocherQty,
                    item.vocherQty - item.approvedVocherQty,
                    item.summary,
                    item.iteM_NAM,
                    moment(item.paY_DAT).format('YYYY-MM-DD'),
                    item.amount,
                    item.cny,
                    item.rat,
                    this.getVariableStatementPayWayText(item.paY_WAY),
                    item.bankName || '--',
                    moment(item.crT_DAT).format('YYYY-MM-DD'),
                ];
                bodyRows.push(row);
            });

            // 總計列
            bodyRows.push([
                '',
                '總計(約當台幣)',
                '',
                _.sumBy(details, 'approvedVocherQty'),
                _.sumBy(details, (o) => o.vocherQty - o.approvedVocherQty),
                '',
                '',
                '',
                _.sumBy(details, (o) => o.amount * o.rat),
                '',
                '',
                '',
                '',
                '',
            ]);

            // 表頭資訊
            const headRows = [
                { label: this.getDateQueryTypeTxt(), value: `${moment(+this.conditions.StartDate).format('YYYY-MM-DD')} ~ ${moment(+this.conditions.EndDate).format('YYYY-MM-DD')}` },
                { label: '製表日期', value: CD },
            ];

            return MyXLSX2.createSheet('財務單帳務匯總表', headRows, bodyHeader, bodyRows);
        },

        getSalarySheet(details) {
            if (!details.length) return null;

            // 內容表頭
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '摘要', width: 20, align: 'left' },
                { text: '財會檢核', width: 10, align: 'center' },
                {
                    text: '核准傳票',
                    width: 9,
                    align: 'center',
                    number: true,
                },
                {
                    text: '待辦傳票',
                    width: 9,
                    align: 'center',
                    number: true,
                },
                { text: '帳務日期', align: 'center' },
                {
                    text: '固定/非固定月薪資總額',
                    width: 23,
                    align: 'right',
                    number: true,
                },
                { text: '績效、獎金', align: 'right', number: true },
                { text: '代扣稅額', align: 'right', number: true },
                { text: '代扣健保', align: 'right', number: true },
                { text: '代扣勞保', align: 'right', number: true },
                { text: '代扣二代健保', align: 'right', number: true },
                { text: '其他代扣', align: 'right', number: true },
                { text: '實付薪資', align: 'right', number: true },
                { text: '幣別', width: 8, align: 'center' },
                { text: '建立日期', align: 'center' },
            ];

            // 內容資料
            const bodyRows = [];
            details.forEach((item) => {
                const row = [
                    // 資訊
                    '',
                    `${moment(`${item.year}/${item.month}/01`).format('YYYY-MM')} 薪資支出`,
                    this.statusTxt(item.vocherStatus),
                    item.approvedVocherQty,
                    item.vocherQty - item.approvedVocherQty,
                    moment(item.dat).format('YYYY-MM-DD'),
                    item.salaryTotal,
                    item.salaryBonus,
                    item.withholdingTax,
                    item.withholdingTax_Health,
                    item.withholdingTax_Labor,
                    item.withholdingTax_Health2,
                    item.withholdingTax_FEE_ELS,
                    item.salaryTotal + item.salaryBonus - item.withholdingTax - item.withholdingTax_Health - item.withholdingTax_Labor - item.withholdingTax_Health2 - item.withholdingTax_FEE_ELS,
                    item.cny,
                    moment(item.crT_DAT).format('YYYY-MM-DD'),
                ];
                bodyRows.push(row);
            });

            // 總計列
            bodyRows.push([
                '',
                '總計(約當台幣)',
                '',
                _.sumBy(details, 'approvedVocherQty'),
                _.sumBy(details, (o) => o.vocherQty - o.approvedVocherQty),
                '',
                _.sumBy(details, 'salaryTotal'),
                _.sumBy(details, 'salaryBonus'),
                _.sumBy(details, 'withholdingTax'),
                _.sumBy(details, 'withholdingTax_Health'),
                _.sumBy(details, 'withholdingTax_Labor'),
                _.sumBy(details, 'withholdingTax_Health2'),
                _.sumBy(details, 'withholdingTax_FEE_ELS'),
                _.sumBy(details, (o) => o.salaryTotal + o.salaryBonus - o.withholdingTax - o.withholdingTax_Health - o.withholdingTax_Labor - o.withholdingTax_Health2 - o.withholdingTax_FEE_ELS),
                '',
                '',
            ]);

            // 表頭資訊
            const headRows = [
                { label: this.getDateQueryTypeTxt(), value: `${moment(+this.conditions.StartDate).format('YYYY-MM-DD')} ~ ${moment(+this.conditions.EndDate).format('YYYY-MM-DD')}` },
                { label: '製表日期', value: CD },
            ];

            return MyXLSX2.createSheet('薪資支出帳務匯總表', headRows, bodyHeader, bodyRows);
        },

        getBankTransferSheet(details) {
            if (!details.length) return null;

            // 內容表頭
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '系統單號', align: 'center' },
                { text: '財會檢核', width: 10, align: 'center' },
                {
                    text: '核准傳票',
                    width: 9,
                    align: 'center',
                    number: true,
                },
                {
                    text: '待辦傳票',
                    width: 9,
                    align: 'center',
                    number: true,
                },
                { text: '轉出帳號', width: 30, align: 'left' },
                { text: '轉出日期', align: 'center' },
                { text: '轉出金額', align: 'right', number: true },
                { text: '幣別', width: 8, align: 'center' },
                {
                    text: '轉出匯率',
                    width: 8,
                    align: 'right',
                },
                { text: '轉出匯費', align: 'right', number: true },

                { text: '轉入帳號', width: 30, align: 'left' },
                { text: '轉入日期', align: 'center' },
                { text: '轉入金額', align: 'right', number: true },
                { text: '幣別', width: 8, align: 'center' },
                {
                    text: '轉入匯率',
                    width: 8,
                    align: 'right',
                },
                { text: '轉入匯費', align: 'right', number: true },
                { text: '成單日期', align: 'center' },
            ];

            // 內容資料
            const bodyRows = [];
            details.forEach((item) => {
                const row = [
                    // 資訊
                    '',
                    item.systemNo,
                    this.statusTxt(item.vocherStatus),
                    item.approvedVocherQty,
                    item.vocherQty - item.approvedVocherQty,
                    item.sourceBankName,
                    moment(item.transferDate).format('YYYY-MM-DD'),
                    item.sourceAmt,
                    item.sourceCny,
                    item.sourceRate,
                    item.sourceFee,
                    item.targetBankName,
                    moment(item.transferDate).format('YYYY-MM-DD'),
                    item.targetAmt,
                    item.targetCny,
                    item.targetRate,
                    item.targetFee,
                    moment(item.crT_DAT).format('YYYY-MM-DD'),
                ];
                bodyRows.push(row);
            });

            // 總計列
            bodyRows.push([
                '',
                '總計(約當台幣)',
                '',
                _.sumBy(details, 'approvedVocherQty'),
                _.sumBy(details, (o) => o.vocherQty - o.approvedVocherQty),
                '',
                '',
                _.sumBy(details, (o) => o.sourceAmt * o.sourceRate),
                '',
                '',
                _.sumBy(details, (o) => o.sourceFee * o.sourceRate),
                '',
                '',
                _.sumBy(details, (o) => o.targetAmt * o.targetRate),
                '',
                '',
                _.sumBy(details, (o) => o.targetFee * o.targetRate),
                '',
            ]);

            // 表頭資訊
            const headRows = [
                { label: this.getDateQueryTypeTxt(), value: `${moment(+this.conditions.StartDate).format('YYYY-MM-DD')} ~ ${moment(+this.conditions.EndDate).format('YYYY-MM-DD')}` },
                { label: '製表日期', value: CD },
            ];

            return MyXLSX2.createSheet('存款帳戶互轉帳務匯總表', headRows, bodyHeader, bodyRows);
        },

        getPettyMoneySheet(details) {
            if (!details.length) return null;

            // 內容表頭
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '系統單號', align: 'center' },
                { text: '財會檢核', width: 10, align: 'center' },
                {
                    text: '核准傳票',
                    width: 9,
                    align: 'center',
                    number: true,
                },
                {
                    text: '待辦傳票',
                    width: 9,
                    align: 'center',
                    number: true,
                },
                { text: '日期', align: 'center' },
                { text: '類型', width: 8, align: 'center' },
                { text: '銀行帳戶', align: 'center' },
                { text: '金額', align: 'right', number: true },
                { text: '備註', width: 30, align: 'left' },
                { text: '建立日期', align: 'center' },
            ];

            // 內容資料
            const bodyRows = [];
            details.forEach((item) => {
                const row = [
                    // 資訊
                    '',
                    item.systemNo,
                    this.statusTxt(item.vocherStatus),
                    item.approvedVocherQty,
                    item.vocherQty - item.approvedVocherQty,
                    moment(item.dat).format('YYYY-MM-DD'),
                    item.typ === 1 ? '轉入' : '轉出',
                    item.bankName || '',
                    item.amt,
                    item.mem,
                    moment(item.crT_DAT).format('YYYY-MM-DD'),
                ];
                bodyRows.push(row);
            });

            // 總計列
            bodyRows.push([
                '',
                '總計(約當台幣)',
                '',
                _.sumBy(details, 'approvedVocherQty'),
                _.sumBy(details, (o) => o.vocherQty - o.approvedVocherQty),
                '',
                '',
                '',
                _.sumBy(details, (o) => (o.typ === 1 ? o.amt : -o.amt)),
                '',
                '',
            ]);

            // 表頭資訊
            const headRows = [
                { label: this.getDateQueryTypeTxt(), value: `${moment(+this.conditions.StartDate).format('YYYY-MM-DD')} ~ ${moment(+this.conditions.EndDate).format('YYYY-MM-DD')}` },
                { label: '製表日期', value: CD },
            ];

            return MyXLSX2.createSheet('零用現金帳務匯總表', headRows, bodyHeader, bodyRows);
        },

        getLoanSheet(details) {
            if (!details.length) return null;

            // 內容表頭
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '借款名稱', width: 30, align: 'left' },
                { text: '財會檢核', width: 10, align: 'center' },
                {
                    text: '核准傳票',
                    width: 9,
                    align: 'center',
                    number: true,
                },
                {
                    text: '待辦傳票',
                    width: 9,
                    align: 'center',
                    number: true,
                },
                { text: '動撥金額', align: 'right', number: true },
                { text: '還款金額', align: 'right', number: true },
                { text: '帳務日期', align: 'center' },
                { text: '借款存入', align: 'right', number: true },
                { text: '存入帳戶', align: 'left' },
                { text: '還款本金', align: 'right', number: true },
                { text: '還款利息', align: 'right', number: true },
                { text: '扣款帳戶', align: 'left' },
                { text: '信保費', align: 'right', number: true },
                { text: '手續費', align: 'right', number: true },
                { text: '匯費', align: 'right', number: true },
                { text: '建立日期', align: 'center' },
            ];

            // 內容資料
            const bodyRows = [];
            details.forEach((item) => {
                const row = [
                    // 資訊
                    '',
                    item.summary,
                    this.statusTxt(item.vocherStatus),
                    item.approvedVocherQty,
                    item.vocherQty - item.approvedVocherQty,
                    item.drawdownAmount || '',
                    item.repaymentAmount || '',
                    item.drawdownAmount ? moment(item.drawdownDate).format('YYYY-MM-DD') : moment(item.repaymentDate).format('YYYY-MM-DD'),
                    item.drawdownAmount || '',
                    item.drawdownAmount ? item.bnK_NAM : '',
                    item.principalAmount || '',
                    item.interestAmount || '',
                    item.repaymentAmount ? item.bnK_NAM : '',
                    item.drawdownAmount ? item.feE_CD_AMT : '',
                    item.drawdownAmount ? item.feE_HAND_AMT : '',
                    item.drawdownAmount ? item.reM_FEE_AMT : '',
                    moment(item.crT_DAT).format('YYYY-MM-DD'),
                ];
                bodyRows.push(row);
            });

            // 總計列
            bodyRows.push([
                '',
                '總計(約當台幣)',
                '',
                _.sumBy(details, 'approvedVocherQty'),
                _.sumBy(details, (o) => o.vocherQty - o.approvedVocherQty),
                _.sumBy(details, 'drawdownAmount'),
                _.sumBy(details, 'repaymentAmount'),
                '',
                '',
                '',
                _.sumBy(details, 'principalAmount'),
                _.sumBy(details, 'interestAmount'),
                '',
                _.sumBy(details, 'feE_CD_AMT'),
                _.sumBy(details, 'feE_HAND_AMT'),
                _.sumBy(details, 'reM_FEE_AMT'),
                '',
            ]);

            // 表頭資訊
            const headRows = [
                { label: this.getDateQueryTypeTxt(), value: `${moment(+this.conditions.StartDate).format('YYYY-MM-DD')} ~ ${moment(+this.conditions.EndDate).format('YYYY-MM-DD')}` },
                { label: '製表日期', value: CD },
            ];

            return MyXLSX2.createSheet('借款管理帳務匯總表', headRows, bodyHeader, bodyRows);
        },

        //
        statusTxt(statusNum) {
            const status = accountingStatusOptions.find((s) => s.key === statusNum);
            if (status) {
                return status.label;
            }
            return '---';
        },
        getTransferTypeText(type) {
            switch (type) {
            case 0:
                return '銀行匯款';
            case 1:
                return '收現金存銀行';
            case 2:
                return '收現金存零用金';
            default:
                return '--';
            }
        },
        getDateQueryTypeTxt() {
            switch (this.conditions.DateQueryType) {
            case 3:
                return this.QueryType === 1 ? '發票開立日期' : '請款單日期';
            case 2:
                return this.accountsDateText;
            default:
                return '建立日期';
            }
        },

        gePaymentPayWayText(val) {
            return _.find(PAY_WAY_LIST, ['value', val])?.label || '--';
        },

        getVariableStatementPayWayText(type) {
            switch (type) {
            case 2:
                return '轉帳';
            default:
                return '--';
            }
        },
    },
};
